"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewFeatureIndicator = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TARGET_MARGIN = 65;
var MOVE_DISTANCE = 10;
var MOVE_DURATION = 600;
var MOVE_ITERATIONS = 5;
var moveAnimation = function (target, position, iterations) {
    var _a, _b, _c;
    if (iterations === void 0) { iterations = MOVE_ITERATIONS; }
    var move = [(_a = {}, _a[position] = 0, _a), (_b = {}, _b[position] = "".concat(MOVE_DISTANCE, "px"), _b), (_c = {}, _c[position] = 0, _c)];
    target.animate(move, {
        duration: MOVE_DURATION,
        iterations: iterations,
        easing: "ease-in-out",
    });
};
var getTooltipPosition = function (tooltipElement, position, stack) {
    if (stack) {
        if (position === kaleidoscope_2.TooltipPosition.Right)
            return { right: "-".concat(tooltipElement.offsetWidth, "px") };
        if (position === kaleidoscope_2.TooltipPosition.Left)
            return { left: "-".concat(tooltipElement.offsetWidth, "px") };
        if (position === kaleidoscope_2.TooltipPosition.Top)
            return { top: "-".concat(tooltipElement.offsetHeight, "px") };
        if (position === kaleidoscope_2.TooltipPosition.Bottom)
            return { bottom: "-".concat(tooltipElement.offsetHeight, "px") };
    }
    else {
        if (position === kaleidoscope_2.TooltipPosition.Right)
            return { marginRight: "".concat(tooltipElement.offsetWidth, "px") };
        if (position === kaleidoscope_2.TooltipPosition.Left)
            return { marginLeft: "".concat(tooltipElement.offsetWidth, "px") };
        if (position === kaleidoscope_2.TooltipPosition.Top)
            return { marginTop: "".concat(tooltipElement.offsetHeight, "px") };
        if (position === kaleidoscope_2.TooltipPosition.Bottom)
            return { marginBottom: "".concat(tooltipElement.offsetHeight, "px") };
    }
    return {};
};
exports.NewFeatureIndicator = (0, mobx_react_1.observer)(function (_a) {
    var children = _a.children, tooltipStack = _a.tooltipStack, animation = _a.animation, indicatorName = _a.indicatorName, className = _a.className, dismissButton = _a.dismissButton, tooltipProps = __rest(_a, ["children", "tooltipStack", "animation", "indicatorName", "className", "dismissButton"]);
    var tooltipRef = (0, react_1.useRef)(undefined);
    var _b = __read((0, react_1.useState)({}), 2), childrenStyle = _b[0], setChildrenStyle = _b[1];
    var newFeaturesIndicatorStore = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore.newFeaturesIndicatorStore;
    (0, react_1.useEffect)(function () {
        if (!newFeaturesIndicatorStore.hide(indicatorName)) {
            setChildrenStyle(getTooltipPosition(tooltipRef.current, tooltipProps.position, tooltipStack));
        }
        setTimeout(function () {
            if (!animation || newFeaturesIndicatorStore.hide(indicatorName))
                return;
            moveAnimation(tooltipRef.current, tooltipProps.position);
        }, 1000);
    }, []);
    if (newFeaturesIndicatorStore.hide(indicatorName))
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("new-feature-indicator", className) },
        react_1.default.createElement(kaleidoscope_2.TooltipElement, __assign({ id: "xyz", forwardRef: tooltipRef, className: "gradient-border" }, tooltipProps),
            react_1.default.createElement("div", { className: "gradient-border__content" },
                react_1.default.createElement(kaleidoscope_1.Label, { size: "m" }, tooltipProps.content),
                dismissButton && (react_1.default.createElement(kaleidoscope_1.Button, { className: "dismiss-button", type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Medium, onClick: function () {
                        newFeaturesIndicatorStore.hideNewFeatureIndicator(indicatorName);
                    } },
                    react_1.default.createElement(icons_1.ThumbsUp, null),
                    "Got it")))),
        react_1.default.createElement("div", { className: "target-text", style: childrenStyle }, children)));
});
